import { PermissionStatus } from './enum/PermissionStatus'
import { PermissionType } from './enum/PermissionType'

export const statusTranslations: Record<PermissionStatus, string> = {
  [PermissionStatus.PENDING]: 'Beklemede',
  [PermissionStatus.APPROVED]: 'Onaylandı',
  [PermissionStatus.REJECTED]: 'Reddedildi',
  [PermissionStatus.CANCELLED]: 'İptal Edildi'
}

export const typeTranslations: Record<PermissionType, string> = {
  [PermissionType.ANNUAL]: 'Yıllık İzin',
  [PermissionType.SICK]: 'Hastalık İzni',
  [PermissionType.MATERNITY]: 'Doğum İzni',
  [PermissionType.PATERNITY]: 'Babalık İzni',
  [PermissionType.UNPAID]: 'Ücretsiz İzin',
  [PermissionType.OTHER]: 'Diğer',
  [PermissionType.MARRIAGE]: 'Evlilik İzni',
  [PermissionType.BEREAVEMENT]: 'Vefat İzni'
}

export const getStatusColor = (status: PermissionStatus) => {
  switch (status) {
    case PermissionStatus.PENDING:
      return 'warning'
    case PermissionStatus.APPROVED:
      return 'success'
    case PermissionStatus.REJECTED:
      return 'error'
    case PermissionStatus.CANCELLED:
      return 'default'
    default:
      return 'default'
  }
} 